import { render, staticRenderFns } from "./page_sidebar.vue?vue&type=template&id=2abcbc64&"
import script from "./page_sidebar.vue?vue&type=script&lang=js&"
export * from "./page_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./page_sidebar.vue?vue&type=style&index=0&id=2abcbc64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports